const initialControlTarget = "none";

export default initialControlTarget;
